import * as React from 'react';
import './styles.scss';

interface TagProps {
  text: string;
  url: string;
}

const Tag = ({ text, url }: TagProps) => (
  <a className="tag" href={url} title={text}>{text}</a>
);

export default Tag;
